// 人员信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'Users/List',
        method: 'post',
        data: data,
    })
}

export const detailApi = (data) => {
    return request({
        url: 'Users/byData',
        method: 'post',
        data: data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'Users/save',
        method: 'post',
        data
    })
}

export const resetPwd = (data) => {
    return request({
        url: 'Users/reset',
        method: 'post',
        data
    })
}

/** 机手/队长列表（仅 role 1、2，不含平台超管） */
export const machinistListApi = (data) => {
    return request({
        url: 'Users/machinist',
        method: 'post',
        data
    })
}

/** 机手 Excel 批量导入 */
export const importMachinistExcelApi = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: 'Users/importMachinistExcel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        timeout: 120000,
    })
}